module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-prior-payment-a43b40c5ba40a32cadef5f8eb8730337.png";